import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AlertBasic } from "./AlertBasic";

export default function AlertSessionLayout() {
  const [listAlert, setListAlert] = useState([]);
  const getAlertBasic = useSelector((state) => state.getAlertBasic);
  const [spam, setSpam] = useState("");

  useEffect(() => {
    // console.log("T003 call list useEffect", getAlertBasic.data);
    if (getAlertBasic.success) {
      //   console.log("T003 call list efect", getAlertBasic.data);
      let i = listAlert;
      let n = i.filter((x) => x.code != getAlertBasic.data?.code);
      if (getAlertBasic.data?.code != null) {
        n.push(getAlertBasic.data);
        setListAlert(n);
      } else {
        i.push(getAlertBasic.data);
        setListAlert(i);
      }
      //   console.log("T003 call list efect after", getAlertBasic.data, i, n);
      setSpam(getAlertBasic.data?.mes);
    }
  }, [getAlertBasic]);
  return (
    <>
      <p className=" hidden">{spam}</p>
      <div className=" flex justify-center absolute bottom-20 right-3">
        <div className="max-w-lg grid grid-cols-1 gap-2">
          {listAlert?.map((n, k) => {
            // console.log("T003 call list efect after ar", k, n);
            let closeAlert = n?.mes == null || n?.mes == "";
            return n.type ? (
              <AlertBasic
                key={k}
                type={n?.type}
                mes={n?.mes}
                closeAlert={closeAlert}
                manualClose={n?.manualClose}
              />
            ) : null;
          })}
        </div>
      </div>
    </>
  );
}
